module.exports = __webpack_public_path__ + "img/header.69ade9dc.jpeg";